<script>
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'PowerPerLamptypeChart',
  components: { Bar },
  props: {
    client_id: Number,
  },
  async mounted() {
    await this.getPowerPerLamptype(this.client_id);
  },
  data() {
    return {
      power_per_lamptype_loading: true,
      power_per_lamptype_data: {},
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Aantal',
            backgroundColor: '#1975aa',
            yAxisID: 'y',
            data: []
          },
          {
            label: 'Energieverbruik',
            backgroundColor: '#c6a900',
            yAxisID: 'y1',
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
        interaction: {
          mode: 'index',
          intersect: false,
        },
        stacked: false,
        scales: {
          y: {
            type: 'linear',
            display: true,
            position: 'left',
          },
          y1: {
            type: 'linear',
            display: true,
            position: 'right',

            // grid line settings
            grid: {
              drawOnChartArea: false, // only want the grid lines for one axis to show up
            },
          },
        }
      }
    }
  },
  watch: {
    client_id: {
      handler(newVal) {
        this.getPowerPerLamptype(newVal);
      }
    }
  },
  methods: {
    async getPowerPerLamptype(client_id) {
      this.power_per_lamptype_loading = true;
      try {
        const response = await fetch(import.meta.env.VITE_API_BASEURL + 'api/dashboard/' + client_id + '/power-per-lamptype', {
          credentials: 'include'
        });

        this.power_per_lamptype_data = await response.json();
      } catch (error) {
        console.error('Error:', error);
      } finally {
        this.fillChartData();
        this.power_per_lamptype_loading = false;
      }
    },
    fillChartData() {
      this.chartData.labels = this.power_per_lamptype_data.labels;
      this.chartData.datasets[0].data = this.power_per_lamptype_data.amount;
      this.chartData.datasets[1].data = this.power_per_lamptype_data.power;
    }
  },
}
</script>

<template>
    <Bar v-if="!power_per_lamptype_loading"
      id="power-per-lamptype-chart"
      :options="chartOptions"
      :data="chartData"
    />
</template>

<style scoped lang="scss">

</style>
